import _, { toNumber } from 'lodash';
import { DepTables, EditStore, EditStoreProps } from '@/main/store/@types/edit.d';
import { zakazkaDruhySet, DEPENDENT_TABLES_ALL as depTableNames } from '@/modules/servis/zakazka/nahradniDily/constants';
import { ZAKAZKA_DRUH, ZAKAZKA_STAV } from '@/modules/servis/zakazka/constants';

import { dropdownList, edit, localState } from './state';
import { editMutations } from './types';

type State = EditStore<typeof edit, typeof dropdownList, typeof localState, DepTables<typeof depTableNames>, EditStoreProps>;

type Data<T = {}> = { data: any & T };

export const mutations = <const>{
	[editMutations.NAHRADNI_DILY_IDENTICKY_ND](state: State, { data }: Data) {
		state.localState.selectedIdenticalNd = data.selectedIdenticalNd;
	},
	[editMutations.NAHRADNI_DILY_SKLAD_MISTO_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.SkladmistoId = data.id;
		state.edit.SkladmistoIdSkladmisto = data.value;
		state.edit.SkladmistoIdPopis = data.text;
	},
	[editMutations.NAHRADNI_DILY_RABAT_SK_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.RabatSk = data.value;
		state.edit.RabatSkText = data.text;
	},
	[editMutations.NAHRADNI_DILY_PRACOVNIK_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.PracovnikId = data.value;
		state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
		state.edit.PracovnikOsobniCis = data.osobniCis;

		if (data.value > 0) {
			state.edit.ProvozovnaId = data.provozovnaId;
			state.edit.StrednaklOzn = data.strednaklOzn;
		}
	},
	[editMutations.NAHRADNI_DILY_NDNR_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.NdNr = data.ndnr;
		state.edit.Text = data.text;
		state.localState.autofocusNezavislyDalsiVydej = true;
		state.localState.selectedNowNdNr = data.value; // TODO: rewrite - ungly temp hack after rewrite this
		state.localState.NdNrLoaded = true;
	},
	[editMutations.NAHRADNI_DILY_KOPIRUJ_ND_SKLAD](state: State, { data }: Data) {
		const ndskladSelectionOne = _.pick(data.ndsklad, ['ZbozidruhOzn', 'OdhcenaPzn', 'NcGd', 'Nc', 'RabatSk', 'RabatSkText', 'PretacPzn', 'SkladmistoId',
			'SkladMjId', 'VydejMjId', 'VydejMjPoc', 'Text', 'Pc']);
		_.assign(state.edit, ndskladSelectionOne);
		state.edit.SkladmistoIdSkladmisto = data.skladmisto.Skladmisto;
		state.edit.SkladmistoIdPopis = data.skladmisto.Popis;
		if (data.isCreateMode) {
			const ndskladSelectionTwo = _.pick(data.ndsklad, ['NdNr', 'Pnc', 'Pc', 'SkladOzn', 'VyrobekndOzn', 'EconomyPrp', 'VydejkandTxt', 'RabatskslevatypPzn']);
			_.assign(state.edit, ndskladSelectionTwo);
			state.edit.NdNrIdx = 1;
			if (data.ndsklad.MimoKusPrp || data.mimoKusPrp) {
				state.edit.MimoKusPrp = true;
			}
			state.edit.Stav = 0;
			state.edit.Poznamka2Dd = !state.edit.Poznamka2Dd ? data.ndsklad.Poznamka2Dd : `${state.edit.Poznamka2Dd} \n ${data.ndsklad.Poznamka2Dd}`;
		}
	},
	[editMutations.NAHRADNI_DILY_REFRESH_FORM_DATA](state: State, { isCreateMode, isEditMode }: { isCreateMode: boolean, isEditMode: boolean }) {
		const { inputEnabled } = state.localState;
		state.localState.nezavislyStav = state.edit.Stav && state.edit.VydejMjPoc ? state.edit.Stav * state.edit.VydejMjPoc : 0;
		state.localState.isOceneniDone = false;
		const zakDruh = state.edit.Zakazka.ZakazkaDruh! as ZAKAZKA_DRUH;
		if (zakazkaDruhySet.has(zakDruh) || (state.edit.SnId && state.edit.SnId > 0)) {
			inputEnabled.sleva = false;
		}
		if (isCreateMode) {
			inputEnabled.vyrobekndOzn = true;
			inputEnabled.skladOzn = true;
			inputEnabled.ndNr = true;
			inputEnabled.text = true;
		} else if (isEditMode) {
			inputEnabled.vyrobekndOzn = false;
			inputEnabled.skladOzn = false;
			inputEnabled.ndNr = false;
			inputEnabled.text = false;
			state.localState.buttonEnabled.cmdSklad = false;
		}
	},
	[editMutations.NAHRADNI_DILY_SET_CONTROLS_FOR_S2](state: State, { navrh }: { navrh: boolean }) {
		const { inputEnabled } = state.localState;
		inputEnabled.skladOzn = navrh;
		inputEnabled.vyrobekndOzn = navrh;
		inputEnabled.ndNr = navrh;
		inputEnabled.skladmisto = false;
		inputEnabled.rabatSk = false;
		inputEnabled.nezavislyDalsiVydej = false;
		inputEnabled.vydejMjId = false;
		inputEnabled.pc = false;
		state.localState.buttonEnabled.cmdSklad = navrh;
	},
	[editMutations.NAHRADNI_DILY_SET_BUTTONS](state: State, { enabled }: { enabled: boolean }) {
		const { buttonEnabled } = state.localState;
		buttonEnabled.cmdMio = enabled && !state.edit.Zakazka.IsNabidka;
		buttonEnabled.cmdMioSklad = enabled && !!state.edit.PermissionMioInsert;
		buttonEnabled.cmdSo = enabled && !state.edit.Zakazka.IsNabidka;
		buttonEnabled.cmdRezervace = enabled && !state.edit.Zakazka.IsNabidka && !!state.edit.PermissionZakazkandRezInsert;
		buttonEnabled.cmdPohyb = enabled;
		buttonEnabled.cmdNDNahradaPred = enabled;
		buttonEnabled.cmdNDNahradaPo = enabled;
		buttonEnabled.cmdShoda = enabled;
		buttonEnabled.cmdAddOld = enabled;
		buttonEnabled.cmdOK = enabled;
		if (state.edit.Zakazka.Stav === ZAKAZKA_STAV.UVOLNENA) {
			buttonEnabled.cmdAddOld = buttonEnabled.cmdAddOld && !state.edit.Zakazka.IsSaga2;
		}
	},
	[editMutations.NAHRADNI_DILY_CLEAR_DATA](state: State, { clearNdNr }: { clearNdNr: number }) {
		if (clearNdNr) {
			state.edit.NdNr = null;
			state.edit.NezavislyDalsiVydej = null;
			state.dependentTables.MoznoVydat.rows = [];
		}
		_.assign(state.edit, {
			PcPevna: null,
			PcSpec: null,
			DphSzbOzn: null,
			ZbozidruhOzn: null,
			OdhcenaPzn: null,
			NcGd: null,
			RabatSk: null,
			PretacPzn: null,
			SkladmistoId: null,
			SkladMjId: null,
			Pc: null,
			VydejMjId: null,
			VydejMjPoc: 0,
			Text: null,
			Pnc: null,
			Kdc: null,
			SnId: null,
			Stav: 0,
			EconomyPrp: false,
			RabatskslevatypPzn: null,
			EanCode: null,
			SkladmistoIdSkladmisto: null,
			SkladmistoIdPopis: null,
		});
		state.localState.labels.pcjedn = null;
		state.localState.labels.pccelk = null;
		state.localState.labels.pcsmlu = null;
		if (state.edit.Zakazka.MimoKusPrp) {
			state.edit.MimoKusPrp = true;
		}
	},
	[editMutations.SET_OCENENI_ND](state: State, { oceneniInput, result }: { oceneniInput: Record<string, any>, result: Record<string, any> }) {
		if (oceneniInput.JednotkovaCena) {
			state.localState.labels.pcjedn = result.LabelPcJednotkova;
			state.edit.UnitPrice = toNumber(state.localState.labels.pcjedn?.substring(result.LabelPcJednotkova.indexOf(':') + 2));
		}
		if (oceneniInput.CelkovaCena) {
			state.localState.labels.pccelk = result.LabelPcCelkova;
		}
		if (oceneniInput.SmluvniCena) {
			state.localState.labels.pcsmlu = result.LabelPcSmluvni;
		}
	},
	[editMutations.ND_SKLAD_ENTITY](state: State, { data }: Data) {
		state.edit.Ndsklad.Pc = data.Pc;
		state.localState.ndsklad.Oznam = data.Oznam;
		state.localState.ndsklad.ZaznamId = data.ZaznamId;
	},
};
